import ReactiveRecord, { Model } from 'reactiverecord';

const routePrefix = ':prefix/employers/projects/:project_id/bids';
class EmployerBid extends Model {
  static routes = {
    update: `${routePrefix}/:id`,
    show: `${routePrefix}/:id`,
  };

  static schema = {
    appointments: Array,
    counter: Boolean,
    employer_resume_url: String,
    id: Number,
    hours: Number,
    interview_scheduled_at: Object,
    mom: Object,
    project: Object,
    proposal_details: String,
    rate: Number,
    billable_rate: Number,
    relevancy_score_rank: Number,
    save_for_later: Boolean,
    start_date: String,
    status: String,
    total: Number,
  };
}

export default ReactiveRecord.model('EmployerBid', EmployerBid);
